import React from 'react'
import { ReactComponent as NoFacilitiesGraphicImage } from 'assets/illustrations/Company.svg'
import { ReactComponent as NoLanesGraphicImage } from 'assets/illustrations/Lanes.svg'
import { LogoIcon } from 'transfix-ui/components/LogoIcon'
import { Typography, Box, makeStyles, BoxProps } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { ReactComponent as NoDataGraphicImage } from './assets/NoDataGraphic.svg'
import { ReactComponent as NoMatchesGraphicImage } from './assets/NoMatchesGraphic.svg'

type TGraphicType = 'no-data' | 'no-matches' | 'no-lanes' | 'no-facilities'

const GRAPHICS: Record<TGraphicType, typeof NoDataGraphicImage> = {
  'no-data': NoDataGraphicImage,
  'no-matches': NoMatchesGraphicImage,
  'no-lanes': NoLanesGraphicImage,
  'no-facilities': NoFacilitiesGraphicImage,
}

const useNoDataGraphicStyles = makeStyles(({ spacing, typography }) => ({
  root: {
    color: brandColors.coolGray6,
  },
  text: {
    color: 'inherit',
    fontSize: typography.h4.fontSize,
    '&:not(:last-child)': {
      marginBottom: spacing(0.5),
    },
  },
  optionalText: {
    maxWidth: '400px',
  },
}))

interface INoDataGraphicProps extends BoxProps {
  /**
   * @default 'No data available'
   */
  mainText?: string
  optionalText?: string
  /**
   * @default 'no-data'
   */
  graphicType?: TGraphicType | 'only-pro'
}

export const NoDataGraphic = (props: INoDataGraphicProps) => {
  const {
    children,
    graphicType = 'no-data',
    mainText = 'No data available',
    optionalText,
    ...boxProps
  } = props

  const GraphicAsset = graphicType === 'only-pro' ? LogoIcon : GRAPHICS[graphicType]

  const classes = useNoDataGraphicStyles()

  return (
    <Box
      {...boxProps}
      className={classes.root}
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      pb={3}>
      <Box mb={2}>
        <GraphicAsset />
      </Box>
      <Typography component='h2' variant='body1' className={classes.text}>
        {mainText}
      </Typography>
      {optionalText && (
        <Typography variant='body2' align='center' className={classes.optionalText}>
          {optionalText}
        </Typography>
      )}
      {children && <Box marginTop={3}>{children}</Box>}
    </Box>
  )
}
